import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig, SensorElementOutput } from "../types.js";

function makeNetworkStatsCluster(
    friendlyName: string,
    elements: SensorElementOutput<any>[],
): SensorClusterConfig<Record<string, never>> {
    return {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: {},
        manufacturerName: "Verdi",
        modelName: "Network Stats",
        friendlyName,
        friendlyShortName: "Network",
        // Return deeply-cloned descriptors each call so clusters cannot accidentally
        // share mutable element descriptors.
        generateSensorElements: () => elements.map((element) => structuredClone(element)),
    };
}

const packetLossAndFrameCount: SensorElementOutput<any>[] = [
    {
        sensorElementConfigKey: "digitalPercentage",
        parameters: {},
        legalConvertedRange: [0, 1],
        subChannel: 0,
    },
    {
        sensorElementConfigKey: "digitalCount",
        parameters: {},
        legalConvertedRange: [0, null],
        subChannel: 1,
    },
];

export const networkStatsClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    Gen4_NetworkStats: makeNetworkStatsCluster("Gen4 Network Stats", packetLossAndFrameCount),

    Sprout_NetworkStats: makeNetworkStatsCluster("Sprout Network Stats", packetLossAndFrameCount),

    SeedSap_NetworkStats: makeNetworkStatsCluster("Seed/Sapling Network Stats", [
        {
            sensorElementConfigKey: "digitalPercentage",
            parameters: {},
            legalConvertedRange: [0, 1],
            subChannel: 0,
        },
    ]),
};
